import {makeService} from './api';

const service = makeService('notes');

export default service;
